export const FETCH_VEHICLES_GROUPS_REQUEST = 'FETCH_VEHICLES_GROUPS_REQUEST';
export const FETCH_VEHICLES_GROUPS_SUCCESS = 'FETCH_VEHICLES_GROUPS_SUCCESS';
export const FETCH_VEHICLES_GROUPS_FAILED = 'FETCH_VEHICLES_GROUPS_FAILED';

export const FETCH_VEHICLE_GROUPS_TIMEZONES_REQUEST = 'FETCH_VEHICLE_GROUPS_TIMEZONES_REQUEST';
export const FETCH_VEHICLE_GROUPS_TIMEZONES_SUCCESS = 'FETCH_VEHICLE_GROUPS_TIMEZONES_SUCCESS';
export const FETCH_VEHICLE_GROUPS_TIMEZONES_FAILED = 'FETCH_VEHICLE_GROUPS_TIMEZONES_FAILED';

export const FETCH_VEHICLES_GROUP_BY_ID_REQUEST = 'FETCH_VEHICLES_GROUP_BY_ID_REQUEST';
export const FETCH_VEHICLES_GROUP_BY_ID_SUCCESS = 'FETCH_VEHICLES_GROUP_BY_ID_SUCCESS';
export const FETCH_VEHICLES_GROUP_BY_ID_FAILED = 'FETCH_VEHICLES_GROUP_BY_ID_FAILED';

export const UPDATE_STEPS_LISTS_REQUEST = 'UPDATE_STEPS_LISTS_REQUEST';
export const UPDATE_STEPS_LISTS_SUCCESS = 'UPDATE_STEPS_LISTS_SUCCESS';
export const UPDATE_STEPS_LISTS_FAILED = 'UPDATE_STEPS_LISTS_FAILED';

export const FETCH_CREATE_VEHICLE_GROUPS_REQUEST = 'FETCH_CREATE_VEHICLE_GROUPS_REQUEST';
export const FETCH_CREATE_VEHICLE_GROUPS_SUCCESS = 'FETCH_CREATE_VEHICLE_GROUPS_SUCCESS';
export const FETCH_CREATE_VEHICLE_GROUPS_FAILED = 'FETCH_CREATE_VEHICLE_GROUPS_FAILED';

export const FETCH_RELATED_RULESETS_REQUEST = 'FETCH_RELATED_RULESETS_REQUEST';
export const FETCH_RELATED_RULESETS_SUCCESS = 'FETCH_RELATED_RULESETS_SUCCESS';
export const FETCH_RELATED_RULESETS_FAILED = 'FETCH_RELATED_RULESETS_FAILED';

export const FETCH_RULESETS_TO_VEHICLES_GROUPS_REQUEST =
  'FETCH_RULESETS_TO_VEHICLES_GROUPS_REQUEST';
export const FETCH_RULESETS_TO_VEHICLES_GROUPS_SUCCESS =
  'FETCH_RULESETS_TO_VEHICLES_GROUPS_SUCCESS';
export const FETCH_RULESETS_TO_VEHICLES_GROUPS_FAILED = 'FETCH_RULESETS_TO_VEHICLES_GROUPS_FAILED';

export const FETCH_UPDATE_STEP_REQUEST = 'FETCH_UPDATE_STEP_REQUEST';
export const FETCH_UPDATE_STEP_SUCCESS = 'FETCH_UPDATE_STEP_SUCCESS';
export const FETCH_UPDATE_STEP_FAILED = 'FETCH_UPDATE_STEP_FAILED';

export const FETCH_ADD_ITEM_TO_VEHICLES_GROUPS_REQUEST =
  'FETCH_ADD_LOCATION_TO_VEHICLES_GROUPS_REQUEST';
export const FETCH_ADD_ITEM_TO_VEHICLES_GROUPS_SUCCESS =
  'FETCH_ADD_LOCATION_TO_VEHICLES_GROUPS_SUCCESS';
export const FETCH_ADD_ITEM_TO_VEHICLES_GROUPS_FAILED =
  'FETCH_ADD_LOCATION_TO_VEHICLES_GROUPS_FAILED';

export const FETCH_REMOVE_ITEM_FROM_VEHICLES_GROUPS_REQUEST =
  'FETCH_REMOVE_ITEM_FROM_VEHICLES_GROUPS_REQUEST';
export const FETCH_REMOVE_ITEM_FROM_VEHICLES_GROUPS_SUCCESS =
  'FETCH_REMOVE_ITEM_FROM_VEHICLES_GROUPS_SUCCESS';
export const FETCH_REMOVE_ITEM_FROM_VEHICLES_GROUPS_FAILED =
  'FETCH_REMOVE_ITEM_FROM_VEHICLES_GROUPS_FAILED';

export const FETCH_VEHICLE_GROUPS_ACTIVATION_REQUEST = 'FETCH_VEHICLE_GROUPS_ACTIVATION_REQUEST';
export const FETCH_VEHICLE_GROUPS_ACTIVATION_SUCCESS = 'FETCH_VEHICLE_GROUPS_ACTIVATION_SUCCESS';
export const FETCH_VEHICLE_GROUPS_ACTIVATION_FAILED = 'FETCH_VEHICLE_GROUPS_ACTIVATION_FAILED';

export const FETCH_VEHICLE_GROUPS_RRS_TIMES_REQUEST = 'FETCH_VEHICLE_GROUPS_RRS_TIMES_REQUEST';
export const FETCH_VEHICLE_GROUPS_RRS_TIMES_SUCCESS = 'FETCH_VEHICLE_GROUPS_RRS_TIMES_SUCCESS';
export const FETCH_VEHICLE_GROUPS_RRS_TIMES_FAILED = 'FETCH_VEHICLE_GROUPS_RRS_TIMES_FAILED';

export const FETCH_RESERVATION_RULESETS_TO_VEHICLES_GROUPS_REQUEST =
  'FETCH_RESERVATION_RULESETS_TO_VEHICLES_GROUPS_REQUEST';
export const FETCH_RESERVATION_RULESETS_TO_VEHICLES_GROUPS_SUCCESS =
  'FETCH_RESERVATION_RULESETS_TO_VEHICLES_GROUPS_SUCCESS';
export const FETCH_RESERVATION_RULESETS_TO_VEHICLES_GROUPS_FAILED =
  'FETCH_RESERVATION_RULESETS_TO_VEHICLES_GROUPS_FAILED';

export const FETCH_VEHICLE_GROUPS_BH_TIMES_REQUEST = 'FETCH_VEHICLE_GROUPS_BH_TIMES_REQUEST';
export const FETCH_VEHICLE_GROUPS_BH_TIMES_SUCCESS = 'FETCH_VEHICLE_GROUPS_BH_TIMES_SUCCESS';
export const FETCH_VEHICLE_GROUPS_BH_TIMES_FAILED = 'FETCH_VEHICLE_GROUPS_BH_TIMES_FAILED';

export const FETCH_BH_RULESETS_TO_VEHICLES_GROUPS_REQUEST =
  'FETCH_BH_RULESETS_TO_VEHICLES_GROUPS_REQUEST';
export const FETCH_BH_RULESETS_TO_VEHICLES_GROUPS_SUCCESS =
  'FETCH_BH_RULESETS_TO_VEHICLES_GROUPS_SUCCESS';
export const FETCH_BH_RULESETS_TO_VEHICLES_GROUPS_FAILED =
  'FETCH_BH_RULESETS_TO_VEHICLES_GROUPS_FAILED';

export const FETCH_DELETE_BH_RULESETS_TO_VEHICLES_GROUPS_REQUEST =
  'FETCH_DELETE_BH_RULESETS_TO_VEHICLES_GROUPS_REQUEST';
export const FETCH_DELETE_BH_RULESETS_TO_VEHICLES_GROUPS_SUCCESS =
  'FETCH_DELETE_BH_RULESETS_TO_VEHICLES_GROUPS_SUCCESS';
export const FETCH_DELETE_BH_RULESETS_TO_VEHICLES_GROUPS_FAILED =
  'FETCH_DELETE_BH_RULESETS_TO_VEHICLES_GROUPS_FAILED';

export const FETCH_DELETE_RESERVATION_RULESETS_TO_VEHICLES_GROUPS_REQUEST =
  'FETCH_DELETE_RESERVATION_RULESETS_TO_VEHICLES_GROUPS_REQUEST';
export const FETCH_DELETE_RESERVATION_RULESETS_TO_VEHICLES_GROUPS_SUCCESS =
  'FETCH_DELETE_RESERVATION_RULESETS_TO_VEHICLES_GROUPS_SUCCESS';
export const FETCH_DELETE_RESERVATION_RULESETS_TO_VEHICLES_GROUPS_FAILED =
  'FETCH_DELETE_RESERVATION_RULESETS_TO_VEHICLES_GROUPS_FAILED';

export const FETCH_UPDATE_VEHICLE_GROUPS_REQUEST = 'FETCH_UPDATE_VEHICLE_GROUPS_REQUEST';
export const FETCH_UPDATE_VEHICLE_GROUPS_SUCCESS = 'FETCH_UPDATE_VEHICLE_GROUPS_SUCCESS';
export const FETCH_UPDATE_VEHICLE_GROUPS_FAILED = 'FETCH_UPDATE_VEHICLE_GROUPS_FAILED';

export const FETCH_FLEETS_SERVICES_REQUEST = 'FETCH_FLEETS_SERVICES_REQUEST';
export const FETCH_FLEETS_SERVICES_SUCCESS = 'FETCH_FLEETS_SERVICES_SUCCESS';
export const FETCH_FLEETS_SERVICES_FAILED = 'FETCH_FLEETS_SERVICES_FAILED';

export const RESET_VEHICLE_GROUPS_OPTIONS = 'RESET_VEHICLE_GROUPS_OPTIONS';
export const RESET_ONBOARDING = 'RESET_ONBOARDING';
export const CHANGE_POSITION = 'CHANGE_POSITION';
export const SET_EXIT = 'SET_EXIT';

export const FETCH_AVAILABLE_SERVICES_REQUEST = 'FETCH_AVAILABLE_SERVICES_REQUEST';
export const FETCH_AVAILABLE_SERVICES_SUCCESS = 'FETCH_AVAILABLE_SERVICES_SUCCESS';
export const FETCH_AVAILABLE_SERVICES_FAILED = 'FETCH_AVAILABLE_SERVICES_FAILED';

export const FETCH_SHARED_SERVICES_REQUEST = 'FETCH_SHARED_SERVICES_REQUEST';
export const FETCH_SHARED_SERVICES_SUCCESS = 'FETCH_SHARED_SERVICES_SUCCESS';
export const FETCH_SHARED_SERVICES_FAILED = 'FETCH_SHARED_SERVICES_FAILED';

export const FETCH_UPDATE_FLEET_REQUEST = 'FETCH_UPDATE_FLEET_REQUEST';
export const FETCH_UPDATE_FLEET_SUCCESS = 'FETCH_UPDATE_FLEET_SUCCESS';
export const FETCH_UPDATE_FLEET_FAILED = 'FETCH_UPDATE_FLEET_FAILED';

export const FETCH_DELETE_VEHICLE_GROUP_REQUEST = 'FETCH_DELETE_VEHICLE_GROUP_REQUEST';
export const FETCH_DELETE_VEHICLE_GROUP_SUCCESS = 'FETCH_DELETE_VEHICLE_GROUP_SUCCESS';
export const FETCH_DELETE_VEHICLE_GROUP_FAILURE = 'FETCH_DELETE_VEHICLE_GROUP_FAILURE';
